export default "__VITE_ASSET__BMI0cxXH__"